// extracted by mini-css-extract-plugin
module.exports = {"loader":"a10a3f92e9--loader--pdm1s","spin":"a10a3f92e9--spin--B3Qmo"};